import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "../../App.css";

const DirectJalBooking = () => {
  const [mobileno, setMobileno] = useState("9999999999");
  const [villa_no, setvilla_no] = useState("");
  const [bookingDate, setBookingDate] = useState(""); // 👈 calendar date
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [bookings, setBookings] = useState([]);

  const [showMessage, setShowMessage] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [message, setMessage] = useState("");

  const registeruser = useRef(null);
   const villaInputRef = useRef(null); // ✅ new ref for focus

  const loggedInUser = localStorage.getItem("username") || "";

  const SAFETY_TIMEOUT_MS = 15000;

  const showMessageWithType = (type, msg) => {
    console.log(`[${type.toUpperCase()}] ${msg}`);
    setMessageType(type);
    setMessage(msg);
    setShowMessage(true);
  };

  useEffect(() => {
    if (showMessage) {
      const timer = setTimeout(() => setShowMessage(false), 8000);
      return () => clearTimeout(timer);
    }
  }, [showMessage]);

  const Required = () => <span style={{ color: "red" }}>*</span>;

  const validateVillaNo = (v) => /^[A-Za-z0-9]+$/.test(v);
  const validateMobileNumber = (m) => /^[6-9]\d{9}$/.test(m);

  // ✅ Default booking date = today (YYYY-MM-DD)
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setBookingDate(today);
  }, []);

  const resetForm = () => {
    setvilla_no("");
    setMobileno("9999999999");
    const today = new Date().toISOString().split("T")[0];
    setBookingDate(today);

    // ✅ Focus villa input after reset
    setTimeout(() => {
      villaInputRef.current?.focus();
    }, 100);
  };

  // ✅ Fetch bookings for selected date
  const fetchBookingsForDate = async (dateStr) => {
    if (!dateStr) return;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/get_bookings`,
        { date: dateStr }, // ✅ must match PHP key
        { timeout: 8000 }
      );

      if (response.data?.status === "success") {
        const sorted = [...response.data.data].sort(
          (a, b) => b.Booking_No - a.Booking_No
        );
        setBookings(sorted);
      } else {
        setBookings([]);
      }
    } catch (error) {
          if (error.response && error.response.status === 404) {
            console.warn("No bookings found for this date.");
            setBookings([]); // Show empty list instead of error
          } else {
            console.error("Error fetching bookings:", error);
          }
    }
  };

  // ✅ Auto fetch whenever date changes
  useEffect(() => {
    if (bookingDate) {
      fetchBookingsForDate(bookingDate);
    }
  }, [bookingDate]);

  // ✅ Convert to API date format (YYYY-MM-DD HH:MM:SS)
  const toApiDateFormat = (isoDate) => `${isoDate} 00:00:00`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);
    let safetyTimer = setTimeout(
      () => setIsSubmitting(false),
      SAFETY_TIMEOUT_MS
    );

    const trimmedVilla = villa_no.trim();
    const trimmedMobile = mobileno.trim();

    if (!trimmedVilla || !trimmedMobile || !bookingDate) {
      showMessageWithType("error", "Please fill all required fields.");
      clearTimeout(safetyTimer);
      setIsSubmitting(false);
      return;
    }

    if (!validateVillaNo(trimmedVilla)) {
      showMessageWithType("error", "Invalid Villa/Plot No.");
      clearTimeout(safetyTimer);
      setIsSubmitting(false);
      return;
    }

    if (!validateMobileNumber(trimmedMobile)) {
      showMessageWithType("error", "Invalid mobile number.");
      clearTimeout(safetyTimer);
      setIsSubmitting(false);
      return;
    }

    const formattedBookingDate = toApiDateFormat(bookingDate);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/Create_Direct_Booking`,
        {
          villa_no: trimmedVilla,
          mobile: trimmedMobile,
          Booked_By: loggedInUser || trimmedMobile,
          Booking_Type: "Direct",
          Booking_Date: formattedBookingDate,
        },
        { timeout: 10000 }
      );

      if (response.status === 200 && response.data?.status === "success") {
        showMessageWithType(
          "success",
          response.data.message || "Booking created successfully!"
        );
        resetForm();
        await fetchBookingsForDate(bookingDate); // ✅ refresh table for same date
      } else {
        showMessageWithType(
          "error",
          response.data?.message || "Booking could not be created."
        );
      }
    } catch (err) {
      console.error("Booking API error:", err);
      showMessageWithType(
        "error",
        "Something went wrong. Please try again later."
      );
    } finally {
      clearTimeout(safetyTimer);
      setTimeout(() => {
        setIsSubmitting(false);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
    }
  };

  // ✅ Helper: Display date in dd-MM-YYYY in table
  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    if (isNaN(date)) return "";
    return date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "-");
  };

  return (
    <div className="container">
      <div className="admin-wrap">
        <div className="box-head">
          <span>Water Booking : जल बुकिंग</span>
        </div>

        <form
          name="registeruser"
          className="login-form"
          onSubmit={handleSubmit}
          ref={registeruser}
        >
          {showMessage && (
            <p className={`${messageType} ${!showMessage && "hidden"}`}>
              {message}
            </p>
          )}

          {/* ✅ Calendar-based Booking Date */}
          <div className="form-group">
            <label
              htmlFor="booking_date"
              style={{
                display: "block",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            >
              Booking Date (बुकिंग दिनांक) <Required />
            </label>
            <input
              id="booking_date"
              type="date"
              name="booking_date"
              value={bookingDate}
              onChange={(e) => setBookingDate(e.target.value)}
              required
            />
            <small>Displayed format: dd-MM-YYYY (Calendar input)</small>
          </div>

          {/* ✅ Villa field */}
          <div className="form-group">
            <label
              htmlFor="villa_no"
              style={{
                display: "block",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            >
              Villa / Plot No. (विला / प्लाट नंबर) <Required />
            </label>
            <input
              id="villa_no"
              type="text"
              name="villa_no"
              required
              placeholder="Villa / Plot No"
              value={villa_no}
              ref={villaInputRef} // ✅ attach ref here
              onChange={(e) => setvilla_no(e.target.value.toUpperCase())}
            />
          </div>

          <div style={{ textAlign: "center" }}>
            <button
              type="submit"
              className="readMoreButton"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>

        {/* ✅ Booking List for selected date */}
        <div className="booking-list" style={{ marginTop: "10px" }}>
          <h6>Bookings for {formatDisplayDate(bookingDate)} (बुकिंग)</h6>
          {bookings.length === 0 ? (
            <p>No bookings found for this date.</p>
          ) : (
            <table
              className="table table-bordered"
              style={{ width: "100%", marginTop: "5px" }}
            >
              <thead>
                <tr>
                  <th>Booking No</th>
                  <th>Villa No</th>
                  <th>Booking Date</th>
                  <th>Last Delivery</th>
                </tr>
              </thead>
              <tbody>
                {bookings.map((b) => {
                  const highlightClass =
                    b.highlight === "yes" ? "highlight-row" : "";
                  return (
                    <tr key={b.Booking_No} className={highlightClass}>
                      <td>{b.Booking_No}</td>
                      <td>{b.Villa_No}</td>
                      <td>{formatDisplayDate(b.Booking_Day)}</td>
                      <td>{formatDisplayDate(b.Last_Delivery_Date)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default DirectJalBooking;
